exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**  rel=\"stylesheet/scss\" lang=\"scss\"*/\n/** backgroud */\n/** border */\n/** table */\n/* Popover\n-------------------------- */\n/* Dialog\n-------------------------- */\n[data-v-a59493b0]:export {\n  xrColorPrimary: #2362FB;\n}\n.wk-checkbox .el-input[data-v-a59493b0] {\n  margin-top: 5px;\n}\n.wk-checkbox .el-checkbox-group[data-v-a59493b0] {\n  line-height: 1.5;\n}\n", ""]);

// exports
